import { render, staticRenderFns } from "./BalanceTable.vue?vue&type=template&id=2a64b174&scoped=true&"
import script from "./BalanceTable.vue?vue&type=script&lang=ts&"
export * from "./BalanceTable.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceTable.vue?vue&type=style&index=0&id=2a64b174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64b174",
  null
  
)

export default component.exports